export const GET_FLAG_REQUEST = "GET_FLAG_REQUEST";
export const GET_FLAG_SUCCESS = "GET_FLAG_SUCCESS";
export const GET_FLAG_FAILURE = "GET_FLAG_FAILURE";
